export default __webpack_public_path__ + "static/media/glacier.17d97cb9.jpeg";